import React, { useEffect } from "react";
import {
    Slide,
    Button,
    Box,
    TextField,
    Select,
    InputLabel,
    FormControl,
    MenuItem,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { useState } from "react";
import { RouteComponentProps } from "react-router";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { ApplicationState } from "../../store";
import * as APIStore from "../../store/APIStore";
import { Send, Cancel } from "@material-ui/icons";
import RequestAccessToken from "../../util/authService";
import NotificationPatient from "./NotificationPatient";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from '@material-ui/core/styles';

type NotificationComposeSingleProps = APIStore.HNIContextState &
    typeof APIStore.actionCreators &
    RouteComponentProps<{ receiverId: string, patientEncounterId: string }>;


const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    input: {
        display: 'none',
    },
}));

const NotificationComposeSingle = (props: NotificationComposeSingleProps) => {

    let {
        submitNewMessageWithAttachment,
        clearMessageState,
        requestConsolidatedPatientById,
        FocusPatient,
        PatientPhysiciansContacts
    } = props;

    
    let location = props.location;
    let newInitialState: APIStore.Message= {};
    let [tokenState, setTokenState] = useState<APIStore.TokenType>();
    let [receiverContact, setReceiverContact] = useState<APIStore.HNIProviderContact>();
    const [newMessageState, setNewMessageState] = useState<APIStore.Message>(newInitialState);

    let tokenStatePr = RequestAccessToken().then((token) => {
        if (token && !tokenState) {
            setTokenState(token);
        }
    });

    const classes = useStyles();
    const history = useHistory();

    let { state } = location;

    let PatientPhysicians = PatientPhysiciansContacts.userPatientContacts;


    let receiverId, patientEncounterId = null;

    if (state) {
        ({ receiverId, patientEncounterId } = state);
    } else {
        history.push(`/notifications/`);
    }


    useEffect(() => {
        if (tokenState?.accessToken && !FocusPatient?.patient) {
            requestConsolidatedPatientById(patientEncounterId, tokenState.accessToken);
        }

    }, [patientEncounterId]);

    useEffect(() => {
        if (FocusPatient?.patient) {      
            setNewMessageState({
                ...newMessageState,
                patient: FocusPatient.patient,
                subject: `Patient ${FocusPatient.patient.lastName}`
            })
        } 
    }, [FocusPatient, receiverId]);

    useEffect(() => {
        if(receiverId && PatientPhysicians.length) {
            let singleContact: APIStore.HNIProviderContact = PatientPhysicians.filter(v => v.email === receiverId)[0];
            setReceiverContact(singleContact);
            if(FocusPatient?.patient) 
            {
                setNewMessageState({
                    ...newMessageState,
                    receiverId: receiverId,
                    subject: `Patient ${FocusPatient.patient.lastName}`
                })
            } else {
                setNewMessageState({
                    ...newMessageState,
                    receiverId: receiverId,
                    subject: `Patient N/A`
                })
            }
            
        }
    }, [receiverId, FocusPatient])



    const goBack = () => {
        history.goBack();
    };

    const handleMessageChange = (e: any) => {
        setNewMessageState({
            ...newMessageState,
            Message: e.target.value,
        });
    };

    const handleSubjectChange = (e: any) => {
        setNewMessageState({
            ...newMessageState,
            subject: e.target.value,
        });
    };

    const handleSend = () => {
        sendFormAndFileState();
        goBack();
    };

    const handleErrorClose = () => {
        clearMessageState();
    };

    const handleFileSelectChange = (e: any) => {
        let file = e.target.files[0];
        let fileName = file.name;

        setNewMessageState({
            ...newMessageState,
            document: file,
            documentFileName: fileName
        });
    }

    const sendFormAndFileState = () => {
        const formData = new FormData();
        for (var key in newMessageState) {
            if (key !== "Document") {
                formData.append(key, newMessageState[key])
            }
        }

        formData.append("PtId", patientEncounterId)
        formData.append("Document", newMessageState.document)
        formData.append("DocumentFileName", newMessageState.documentFileName)

        submitNewMessageWithAttachment(formData, tokenState.accessToken)
    }

    if (!newMessageState || !receiverContact?.email) {
        return (<React.Fragment></React.Fragment>);
    }

    return (
        <Slide in timeout={1000} direction="left">
            <div>
                <Grid container spacing={8} className="noticebar">
                    <Grid item>
                        <Button onClick={handleSend} startIcon={<Send />}>
                            <Hidden xsDown>Send</Hidden>
                        </Button>
                        <Button onClick={goBack} startIcon={<Cancel />}>
                            <Hidden xsDown>Cancel</Hidden>
                        </Button>
                    </Grid>
                </Grid>
                <Box m={4}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="stretch"
                        spacing={4}
                    >
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="standard">

                                <TextField

                                    id="compose-message-receiver"
                                    value={`${receiverContact.displayName} - ${receiverContact.type}`}
                                    label="To"
                                    variant="standard"
                                />

                            </FormControl>
                        </Grid>
                        <Grid direction="row" item xs={12} sm={12}>

                            <Grid item xs={4} sm={4}>
                                <TextField
                                    id="compose-message-subject"
                                    onChange={(e) => {handleSubjectChange(e)}}
                                    value={newMessageState.subject}
                                    label="Subject"
                                    variant="standard"
                                />
                            </Grid>
                            <Grid item xs={4} sm={4}>
                                <NotificationPatient message={newMessageState} />
                            </Grid>


                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                id="compose-message-box"
                                label="Message"
                                multiline
                                onChange={handleMessageChange}
                                rows={4}
                                value={newMessageState.Message}
                                defaultValue=""
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>


                            <FormControl>
                                <input
                                    className={classes.input}
                                    accept=""
                                    onChange={handleFileSelectChange}
                                    id="contained-button-file"
                                    multiple
                                    type="file"
                                />
                                <label htmlFor="contained-button-file">
                                    <Button variant="outlined" component="span">
                                        {
                                            newMessageState.documentFileName ? newMessageState.documentFileName : "Upload Document"
                                        }
                                    </Button>
                                </label>
                            </FormControl>

                        </Grid>
                    </Grid>

                </Box>

            </div>
        </Slide>
    );


};
export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(NotificationComposeSingle as any);
